/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetEventLastSeenPathParams = NonNullable<operations['getEventLastSeen']['parameters']['path']>;

export type GetEventLastSeenQueryParams = NonNullable<operations['getEventLastSeen']['parameters']['query']>;

export interface Input extends GetEventLastSeenPathParams {
  apiVersion?: string;
  query?: GetEventLastSeenQueryParams;
}

export async function getEventLastSeen(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/metrics/{metricKey}/event-last-seen', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
